module.exports = __webpack_public_path__ + "public/StoreIcon/hidePwsd.svg?6fce3a19";